<template>
  <div class="project-order-detail-card">
    <div class="order-detail-title">
      <div class="my-breadcrumb pdb20">
        <span>我的位置：</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/user/order/list/' + this.order.group }">订单管理</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="container mgt20">
      <p class="title">订单状态</p>
      <el-steps :active="stepIndex" align-center>
        <el-step v-for="(item, index) in stepList" :key="index" :title="item.finish_name"
          :description="`${order[item.field] || ''}`"></el-step>
      </el-steps>
    </div>
    <div class="order-info">

      <div class="order-detail ">

      </div>
      <div class="table-wrap">
        <!-- 表格 -->

        <el-table class="xm-table" :data="[order]">
          <el-table-column label="订单信息" align="center" minWidth="400">
            <template slot-scope="{row}">
              <div class="row01 flex-row">
                <div class="flex-grow-1 mgl10 tal">订单号：{{ row.order_no }} </div>
                <div class="flex-grow-0">时间：{{ row.create_time }}</div>
              </div>
              <div class="row002" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                <div class="flex-col goods" v-for="(goods, index) in row.product" :key="index">
                  <div class="flex-row mgt10 mgl10 tal">
                    <div class="flex-grow-0 mgr10">
                      <el-image style="width: 70px;height: 70px;" :src="goods.cover"></el-image>
                    </div>
                    <div class="flex-grow-1 flex-col">
                      <div class="name">
                        <span>{{ goods.name }}</span>
                      </div>
                      <div class="desc">
                        <span>×{{ goods.num }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="金额" align="center" width="120">
            <template slot-scope="{row}">
              <div class="row01">
              </div>
              <div class="row02 flex-xy-center flex-col"
                :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                <template v-if="row.integral_amount > 0">
                  <span>实付：{{ row.integral_amount }}积分</span>
                </template>
                <template v-if="row.order_amount > 0">
                  <span>总额：{{ row.order_amount }}元</span>
                  <span>实付：{{ row.pay_amount }}元</span>
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="{row}">
              <div class="row01">
              </div>
              <div class="row02 flex-xy-center" :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                <span style="color:#FF8F1F;">{{ row.status_name }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="100" fixed="right">
            <template slot-scope="{row}">
              <div class="row01">
              </div>
              <div class="row02 flex-xy-center flex-col"
                :style="{ 'height': (row.product.length * tableRowHeight) + 'px' }">
                <!-- <el-button v-if="row.report.length > 0" type="text" @click="handleDownload(row)">下载报告</el-button> -->
                <template v-if="[25].includes(row.status)">
                  <el-button type="text" @click="handleService(row)">申请复测</el-button>
                  <el-button type="text" @click="handleSure(row)">确认结果</el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <div class="total">
        <div class="col-l"></div>
        <div class="col-r">
          <p class="tit">订单总额 :</p>
          <template v-if="order.integral_amount > 0">
            <p>{{ order.integral_amount }}积分</p>
          </template>
          <template v-else>
            <p><i>¥{{ order.order_amount }}元</i></p>
          </template>
          <template v-if="order.coupon_amount > 0">
            <p class="tit">优惠券 :</p>
            <p><i>-¥{{ order.coupon_amount }}元</i></p>
          </template>
          <template v-if="order.discount_amount > 0">
            <p class="tit">会员折扣 :</p>
            <p><i>-¥{{ order.discount_amount }}元</i></p>
          </template>
          <template v-if="order.balance_amount > 0">
            <p class="tit">余额支付 :</p>
            <p><i>￥{{ order.balance_amount }}元</i></p>
          </template>
          <template v-if="order.credit_deposit_amount > 0">
            <p class="tit">信用金支付 :</p>
            <p><i>￥{{ order.credit_deposit_amount }}元</i></p>
          </template>
          <template v-if="order.express_amount > 0">
            <p class="tit">运费 :</p>
            <p><i>{{ formatPrice(order.express_amount) }}元</i></p>
          </template>
          <template v-if="order.integral_amount > 0">
            <p class="total-tit">实付款 :</p>
            <p class="total-tit"><i>{{ order.integral_amount }}积分</i></p>
          </template>
          <template v-else>
            <p class="total-tit">实付款 :</p>
            <p class="total-tit"><i>¥{{ order.pay_amount }}元</i></p>
          </template>
        </div>
      </div>
    </div>
    <div class="container mgb20" v-if="order.group == 'project' || order.group == 'service'">
      <p class="title">其他信息</p>
      <el-descriptions title="" size="small" :column="2" border>
        <el-descriptions-item label="联系人">{{ order.linkman }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ order.linknum }}</el-descriptions-item>
        <template v-if="order.group == 'project'">
          <el-descriptions-item label="送样方式">{{ order.sample_type_name }}</el-descriptions-item>
          <!-- <el-descriptions-item label="邮寄地址">{{ order.sample_detail }}</el-descriptions-item> -->
          <el-descriptions-item label="测试同设备">{{ order.sample_order_id ? '是' : '否' }}</el-descriptions-item>
          <el-descriptions-item label="样品回收">{{ order.recovery ? '是' : '否' }}</el-descriptions-item>
        </template>
        <el-descriptions-item label="是否加急">{{ order.urgent ? '是' : '否' }}</el-descriptions-item>

        <el-descriptions-item label="结果报告">
          <el-link v-for="(item, index) in order.report" type="primary" :href="item.url" :key="item.url"
            target="_blank">附件{{ index + 1
            }}</el-link>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="container" v-if="order.group == 'project' || order.group == 'service'">
      <p class="title">寄送地址</p>
      <div class="mgb20">
        <el-descriptions title="" size="small" :column="2" border>
          <el-descriptions-item label="收件人">{{ order.supplier_address_name }}</el-descriptions-item>
          <el-descriptions-item label="收件人电话">{{ order.supplier_seller_phone }}</el-descriptions-item>
          <el-descriptions-item label="详细地址">{{ order.supplier_address_province }}{{ order.supplier_address_city }}{{
            order.supplier_address_district }}{{ order.supplier_address_detail }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>


    <div class="container" v-if="order.model == 'project'">
      <p class="title">实验信息</p>
      <div class="mgb20" v-for="(sample, index) in order.content" :key="index">
        <el-descriptions :title="sample.name" size="small" :column="2" border>
          <el-descriptions-item label="样品数量">{{ sample.count }}</el-descriptions-item>
          <el-descriptions-item label="样品编号">{{ sample.code }}</el-descriptions-item>
          <el-descriptions-item v-for="(form, idx) in sample.formList" :key="idx" :label="form.config.name">{{
            Array.isArray(form.value) ? form.value.join(',') : form.value
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </div>


  </div>
</template>

<script>

import { getOrderDetail, setSure, setService } from "@/api/order";

export default {
  name: "OrderDetail",
  components: {

  },
  props: {},
  data() {
    return {
      orderId: 0,
      order: {
        product: [],
        report: [],
      },
      stepIndex: 0,
      stepList: [],
      emptyText: '暂无数据',
      loading: false,
      tableRowHeight: 90,
    }
  },
  computed: {

  },
  created() {
    this.orderId = this.$route.query.id
    this.getOrderDetail()
  },
  mounted() {
    this.formatPrice = this.utils.formatPrice
  },
  updated() {

  },
  methods: {
    getOrderDetail() {
      getOrderDetail({ id: this.orderId }).then((res) => {
        this.order = res.data.detail
        this.stepIndex = res.data.stepIndex
        this.stepList = res.data.stepList
      }).catch((err) => {
        console.log(err);
      })
    },
    handleDownload() {
      window.open(this.order.report[0].url, '_blank');
    },
    // 申请复测
    handleService(order) {
      this.$confirm('确认申请复测吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        setService({
          id: order.id
        }).then((response) => {
          this.loading = false;
          this.getOrderStatusStat();
          this.getList();
          this.$message({
            type: 'success',
            message: '确认成功!'
          });
        })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    // 确认订单
    handleSure(order) {
      this.$confirm('确定确认订单结果吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loading = true;
        setSure({
          id: order.id
        }).then((response) => {
          this.loading = false;
          this.getOrderStatusStat();
          this.getList();
          this.$message({
            type: 'success',
            message: '确认成功!'
          });
        })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.project-order-detail-card {
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
  border-radius: 2px;
  margin-top: 16px;

  .order-detail-title {
    width: 100%;
    padding: 19px 25px 0 25px;
    border-bottom: 1px solid #CCD7DB;
  }

  .order-info {
    width: 100%;
    padding: 17px 27px 30px 27px;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #222222;
    }

    .order-detail {
      margin-top: 20px;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      color: #6F7F84;
    }

    .order-detail div:nth-child(even) {
      color: #222222 !important;
      margin-right: 40px;
    }

    .total {
      width: 100%;
      padding: 24px 54px 20px 28px;
      box-sizing: border-box;
      background: #E9F3F6;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;

      .col-l {
        font-size: 12px;
        font-weight: 400;
        color: #6F7F84;
        line-height: 24px;
      }

      .col-r {
        display: grid;
        column-gap: 20px;
        grid-template-columns: 80px auto;
        font-size: 12px;
        font-weight: 400;
        color: #222222;
        line-height: 24px;
        text-align: right;

        .total-tit {
          font-size: 20px;
          font-weight: 400;
          color: #222222;
          margin-top: 9px;
        }

        i {
          color: #FF6666 !important;
        }

        .tit {
          font-size: 12px;
          font-weight: 400;
          color: #6F7F84;
        }
      }
    }
  }


  .container {
    width: 100%;
    padding: 0px 25px 0px 25px;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #222222;
      margin-bottom: 20px;
      background: #E9F3F6;
      padding: 15px;
    }
  }

  .el-button {
    margin-left: 0px;
    padding: 5px 0;
  }
}
</style>
